import { useEffect, useRef, useState } from "react"

// Debounces `value`, but only re-renders when the debounced result actually
// changes. Equality is by `keyOf(value)` so callers can pass non-primitive
// values (e.g. dayjs objects) whose identity changes without the content doing.
// keyOf may be an inline arrow (new each render) — held in a ref so it never
// re-triggers the timer on its own.
export function useDebouncedValue(value, delay = 150, keyOf = (v) => v) {
  const keyOfRef = useRef(keyOf)
  keyOfRef.current = keyOf

  const [debounced, setDebounced] = useState(value)
  const latestKey = useRef(keyOfRef.current(debounced))

  useEffect(() => {
    if (keyOfRef.current(value) === latestKey.current) return
    const id = setTimeout(() => {
      latestKey.current = keyOfRef.current(value)
      setDebounced(value)
    }, delay)
    return () => clearTimeout(id)
  }, [value, delay])

  return debounced
}
